import React from 'react';
import {styled, TableHead, Typography} from '@mui/material';
import {capitalize} from 'lodash';
import PropTypes from 'prop-types';
import {formatDate} from '../../../../util/date';
import {renderAmount} from '../../../../util';
import {StyledBodyCell, StyledHeadCell, StyledTableRow} from '../components';
import {GREY_90} from '../../../../theme';
import {firstColWidth} from '../constants';
const StyledTableHead = styled(TableHead)(() => ({
  position: 'sticky',
  zIndex: 2,
  top: 0,
}));

export function BalanceSheetHead({
  balanceSheetData,
  differenceData,
  firstColRef,
}) {
  if (!balanceSheetData) {
    return null;
  }
  const [period, previousPeriod] = Object.keys(balanceSheetData);

  function renderCategoryRow() {
    return (
      <StyledTableRow>
        <StyledBodyCell
          sx={{
            left: 0,
            width: firstColWidth,
            minWidth: firstColWidth,
            maxWidth: firstColWidth,
            position: 'sticky',
          }}
          ref={firstColRef}
        />
        <StyledBodyCell sx={{left: firstColWidth, position: 'sticky'}} />
        {balanceSheetData[period].map(({pli_name: pliName}) => (
          <StyledHeadCell key={pliName}>
            <Typography sx={{fontWeight: 'bold'}}>
              {capitalize(pliName)}
            </Typography>
          </StyledHeadCell>
        ))}
      </StyledTableRow>
    );
  }

  function renderPeriodRow(periodKey, spanRow = false) {
    return (
      <StyledTableRow>
        {spanRow ? (
          <StyledBodyCell
            sx={{
              left: 0,
              position: 'sticky',
            }}
            rowSpan={2}
          />
        ) : null}

        <StyledBodyCell sx={{left: firstColWidth, position: 'sticky'}}>
          <Typography sx={{fontWeight: 'bold'}}>
            {formatDate(periodKey)}
          </Typography>
        </StyledBodyCell>

        {balanceSheetData[periodKey].map(({pli_id: id, amount}, idx) => (
          <StyledBodyCell
            key={`${periodKey}-${id}-value-${idx}`}
            sx={{textAlign: 'right'}}
          >
            <Typography>{renderAmount(amount)}</Typography>
          </StyledBodyCell>
        ))}
      </StyledTableRow>
    );
  }

  function renderDifferenceRow() {
    return (
      <StyledTableRow>
        <StyledBodyCell sx={{left: 0, position: 'sticky'}} />
        <StyledBodyCell sx={{left: firstColWidth, position: 'sticky'}}>
          <Typography sx={{fontWeight: 'bold'}}>Difference</Typography>
        </StyledBodyCell>
        {differenceData.map((amount, idx) => {
          return (
            <StyledBodyCell
              key={`difference-${idx}`}
              sx={{
                textAlign: 'right',
                borderTop: `1px solid ${GREY_90} !important`,
              }}
            >
              <Typography>{renderAmount(amount)}</Typography>
            </StyledBodyCell>
          );
        })}
      </StyledTableRow>
    );
  }

  return (
    <StyledTableHead>
      {renderCategoryRow()}
      {renderPeriodRow(period, true)}
      {renderPeriodRow(previousPeriod)}
      {renderDifferenceRow()}
    </StyledTableHead>
  );
}

BalanceSheetHead.propTypes = {
  balanceSheetData: PropTypes.object.isRequired,
  differenceData: PropTypes.array.isRequired,
  firstColRef: PropTypes.any,
};
